import { ScopeableType } from '../../../types';
import { ScopeItem } from '../../form-fields/scope-selector/scope-selector-constants';

export interface RevenueShareFormValues {
  clientId: number | null;
  partnershipId: number | null;
  effectiveYear: number | null;
  discount: number | null;
  applyToPrice: boolean;
  scopeableType: ScopeableType;
  scopes: ScopeItem[];
}

export interface ParsedRevenueShareValues {
  clientId: number | null;
  partnershipId: number | null;
  effectiveYear: number;
  discount: number;
  applyToPrice: boolean;
  scopes: ScopeItem[];
}

export const DEFAULT_REVENUE_SHARE_FORM_VALUES: RevenueShareFormValues = {
  clientId: null,
  partnershipId: null,
  effectiveYear: null,
  discount: null,
  applyToPrice: false,
  scopeableType: ScopeableType.Global,
  scopes: [],
};
